import React from "react";

export interface FilterChips<T extends string> {
  options: { value: T; label: string }[];
  selected: T;
  onSelect: (value: T) => void;
  label: string;
}

export const FilterChips = <T extends string>({
  options,
  selected,
  onSelect,
  label,
}: FilterChips<T>): JSX.Element => (
  <div
    role="group"
    aria-label={label}
    className="flex flex-wrap gap-2 font-display text-ui font-semibold"
  >
    {options.map(({ value, label: text }) => (
      <button
        key={value}
        type="button"
        aria-pressed={value === selected}
        onClick={() => onSelect(value)}
        className={`rounded-full border-2 border-ink px-3.5 py-1.5 transition duration-maker ease-maker ${
          value === selected
            ? "bg-ink text-white"
            : "bg-paper text-ink hover:shadow-hard"
        }`}
      >
        {text}
      </button>
    ))}
  </div>
);
